import React from "react";
import { Helmet } from "react-helmet";
import LeadFormSection from "@webcore/components/domain/content-site/sections/LeadFormSection";

// Kept for the success state only: the lead is captured first, then offered a time slot.
const calendarHref = "https://calendar.app.google/rQuDdWM57HswfdSB9";

const expectations = [
  {
    step: "01 / reply",
    text: "A human replies within one business day with a couple of times that work.",
  },
  {
    step: "02 / walkthrough",
    text: "Thirty minutes on your stack. We bring the reconciliation question you gave us and walk through the job that answers it - Pipeline Review, MRR Close, Commission Run, or Variance Reporting - on real connected data.",
  },
  {
    step: "03 / next step",
    text: "If it's a fit, we scope a pilot on your systems. If it isn't, we'll say so.",
  },
];

const BookADemo: React.FC = () => {
  return (
    <>
      <Helmet>
        <title>Book a Demo — DataFabrIQ</title>
        <meta
          name="description"
          content="Book a walkthrough of DataFabrIQ on a stack like yours. Tell us where reporting breaks today and we reply within one business day."
        />
        <link rel="canonical" href="https://datafabriq.co/book-a-demo" />
      </Helmet>

      <section className="cs-section cs-lead" data-testid="book-a-demo">
        <div className="cs-lead-inner">
          <div className="cs-lead-copy">
            <div className="eyebrow">// book a demo</div>
            <h1>
              One call. <span className="serif">Your data,</span><br />
              not a canned deck.
            </h1>
            <p className="cs-lead-lede">
              Tell us where reporting breaks today - the MRR that doesn't tie to billing, the pipeline
              number that changes between Monday and the board meeting, the commission run that takes
              a week. We'll show you how DataFabrIQ handles that exact job on a stack like yours.
            </p>
            <ol className="cs-lead-steps">
              {expectations.map((item) => (
                <li key={item.step} className="cs-lead-step">
                  <span className="cs-lead-step-label">{item.step}</span>
                  <p>{item.text}</p>
                </li>
              ))}
            </ol>
          </div>

          <LeadFormSection pageSlug="/lp/data-platform" calendarHref={calendarHref} />
        </div>
      </section>
    </>
  );
};

export default BookADemo;
